import { withStyles, TableCell, makeStyles } from '@material-ui/core';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import { colours, Headline, Paragraph, Subheader } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';

const maxWidth = '1254px';

export const SearchResultsTableCell = withStyles({
  root: {
    border: colours.white,
    padding: 0,
    fontFamily: 'SourceSansPro',
    fontSize: '16px',
    '&.MuiTableCell-head': {
      fontWeight: 'bold',
    },
  },
})(TableCell);

export const StyledTableContainer = styled.div`
  margin: 62px 0 140px 0;
  width: 741px;
`;

export const StyledImportExportIcon = withStyles({
  root: {
    color: colours.black,
    fontSize: '18px',
  },
})(ImportExportIcon);

export const useStyles = makeStyles({
  root: {
    fontSize: '16px',
  },
});

export const StyledSubheader = styled(Subheader)`
  margin-top: 8px;
  font-family: SourceSansPro;
  font-weight: bold;
`;

export const StyledHeadline = styled(Headline)`
  margin: 8px 0px 16px 0px;
  line-height: 60px;
`;

export const StyledParagraph = styled(Paragraph)`
  margin: 16px 0px 64px 0px;
`;

export const StyledReportLink = styled.div`
  max-width: ${maxWidth};
  text-align: right;
`;

export const StyledTableWrapper = styled.div`
  max-width: ${maxWidth};
`;

export const StyledDownloadLinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
